<template>
    <a-config-provider :locale="locale">
        <a-layout id="components-layout-demo-custom-trigger" v-if="isLogged">
            <!-- -------------------------------
                            SIDEBAR
            -------------------------------- -->
            <a-layout-sider :trigger="null" collapsible v-model="collapsed">
                <div class="logo">
                    <img src="/logo.png" alt="main logo" style="width:100%;">
                </div>

                <a-menu theme="dark" mode="inline" :defaultSelectedKeys="[$route.path]">
                    <a-menu-item v-for="({ icon, name }) in routes" :key="name" @click="$router.push({ name, query: { page: 1 } })">
                        <a-icon :type="icon" />
                        <span>{{ lang.sidebar[name] }}</span>
                    </a-menu-item>
                </a-menu>
            </a-layout-sider>
            <a-layout>
                <!-- -----------------------------
                                NAVBAR
                ------------------------------ -->
                <a-layout-header style="background: #fff; padding: 0; display: flex; justify-content: space-between; position: fixed; z-index: 1" :class="['_header', { '_collapsed': collapsed }]">
                    <!-- TOGGLE EXPAND ICON -->
                    <a-tooltip placement="right">
                        <template slot="title">
                            <span>{{ collapsed ? lang.navbar.contract : lang.navbar.expand }}</span>
                        </template>
                        <a-icon class="trigger" :type="collapsed ? 'menu-unfold' : 'menu-fold'" @click="collapsed = !collapsed"/>
                    </a-tooltip>

                    <!-- <select v-model="$store.state.lang" @change="translate($event.target.value)">
                        <option value=""></option>
                        <option v-for="(language, key) in lang.languages" :value="language.iso_2" :key="key">{{ language.name }}</option>
                    </select> -->

                    <!-- ACTIONS -->
                    <a-menu mode="horizontal" :style="{ lineHeight: '64px' }">
                        <a-menu-item key="2" @click="showCart = !showCart" v-if="!loggedUserIsAdmin">
                            <a-badge :count="totalByEachItemInCart">
                                <a-tooltip placement="bottom">
                                    <template slot="title">
                                        <span>{{ lang.navbar.order }}</span>
                                    </template>
                                    <a-icon type="shopping-cart" />
                                </a-tooltip>
                            </a-badge>
                        </a-menu-item>
                        <a-menu-item key="3">
                            <a-dropdown :trigger="['click']">
                                <a-button type="link">
                                    {{ user.name }}
                                </a-button>
                                <a-menu slot="overlay">
                                  <a-menu-item key="0" @click="showPasswordChange = true">
                                    Cambiar contraseña
                                  </a-menu-item>
                                  <a-menu-item key="1" @click="logout">
                                      Cerrar sesión
                                  </a-menu-item>
                                </a-menu>
                            </a-dropdown>
                        </a-menu-item>
                    </a-menu>
                </a-layout-header>
                <a-layout-content :style="{ margin: '64px 0 0 0', padding: '24px', background: '#fff', flexGrow: 1 }">
                    <router-view></router-view>
                </a-layout-content>
                <a-drawer :title="`${lang.sidebar.order_elements} (${totalByEachItemInCart})`" placement="right" closable @close="showCart = !showCart" :visible="showCart" width="300">
                    <a-list itemLayout="vertical" :data-source="cart">
                        <a-list-item slot="renderItem" slot-scope="item, index">
                            <div style="padding: 0 16px">
                                <h3>{{ item.name }}</h3>
                                <h3 style="display: inline-block">Tipo:</h3> <i>{{ lang.watch.main_table[item.field] }}</i> <br/>
                                <small>{{ lang.sidebar.quantity }}: {{ item.quantity }}</small>
                            </div>
                            <a-button v-for="{type, action} in actions" :key="type" :icon="type" @click="action(index)" type="link" slot="actions" :style="[type == 'delete' && { color: 'red' }]"/>
                        </a-list-item>
                        <div v-if="loggedUserIsMerchant && itemsInCart > 0" style="padding: 16px">
                            <a-input v-model="merchant" placeholder="Comerciante" />
                        </div>
                        <div v-if="itemsInCart > 0" :disabled="isLoadingCart" style="padding: 16px">
                            <h3>{{ lang.sidebar.observations }}:</h3>
                            <a-textarea v-model="cartNote" placeholder="(opcional)"></a-textarea>
                        </div>
                        <div style="padding: 16px">
                            <a-button slot="footer" block type="primary" @click="send({ note: cartNote, target_username: merchant })" v-if="itemsInCart > 0" :disabled="isLoadingCart" :loading="isLoadingCart">Solicitar</a-button>
                        </div>
                    </a-list>
                </a-drawer>
            </a-layout>

          <a-modal :visible="showPasswordChange" @cancel="showPasswordChange = false" @ok="updatePassword" :ok-button-props="{ props: { disabled: !bothPasswordsMatch } }">
            <a-form-item label="Contraseña actual">
                <a-input-password
                    id="current_password"
                    v-model="passwords.current_password"
                    placeholder="Contraseña actual">
                    <a-icon slot="prefix" type="lock" style="color: rgba(0,0,0,.25)" />
                </a-input-password>
            </a-form-item>
            <a-form-item label="Nueva contraseña">
              <a-input-password
                id="password"
                v-model="passwords.password"
                placeholder="Contraseña">
                <a-icon slot="prefix" type="lock" style="color: rgba(0,0,0,.25)" />
              </a-input-password>
            </a-form-item>

            <a-form-item label="Repetir contraseña">
              <a-input-password
                id="password_repeat"
                v-model="passwords.password_repeat"
                placeholder="Contraseña">
                <a-icon slot="prefix" type="lock" style="color: rgba(0,0,0,.25)" />
              </a-input-password>
            </a-form-item>
          </a-modal>
        </a-layout>
        <router-view v-else></router-view>
    </a-config-provider>
</template>

<script>
import { mapGetters, mapActions, mapState } from 'vuex';
import es from 'ant-design-vue/lib/locale-provider/es_ES';
import { Role } from '@/constants'
import {sendPasswordReset, updateUser} from "../api";
export default {
    data: () => ({
        collapsed: false,
        showCart: false,
        customize: false,
        locale: es,
        passwords: {
            current_password: '',
            password: '',
            password_repeat: ''
        },
        showPasswordChange: false,
        cartNote: '',
        merchant: ''
    }),
    methods: {
        ...mapActions({
            logout: 'session/logout',
            removeFromCart: 'watch/removeFromCart',
            incrementPartQuantity: 'watch/incrementPartQuantity',
            decrementPartQuantity: 'watch/decrementPartQuantity',
            send: 'watch/send',
            translate: 'translate'
        }),
      updatePassword() {
        updateUser({...this.passwords, id: this.user.id})
          .then(() => {
            this.$notification.open({
              message: 'Éxito!',
              description: 'Se ha enviado un correo para actualizar su contraseña, por favor revise su bandeja de correo',
              duration: 0,
              icon: () => (<a-icon type="smile" style="color: #48BE83" />),
            });
            this.showPasswordChange = false
          })
      },
        sendPasswordReset() {
            sendPasswordReset({
                email: this.user.email
            })
            .then(() => {
                this.$notification.open({
                    message: 'Éxito!',
                    description: 'Se ha enviado un correo para actualizar su contraseña, por favor revise su bandeja de correo',
                    duration: 0,
                    icon: () => (<a-icon type="smile" style="color: #48BE83" />),
                });
            })
        }
    },
    computed: {
      bothPasswordsMatch() {
        return this.passwords.password === this.passwords.password_repeat && Object.values(this.passwords).every(password => password.length > 5)
      },
        ...mapGetters({
            isLogged: 'session/isLogged',
            itemsInCart: 'watch/itemsInCart',
            totalByEachItemInCart: 'watch/totalByEachItemInCart',
            lang: 'lang',
            loggedUserIsAdmin: 'session/loggedUserIsAdmin',
            loggedUserIsMerchant: 'session/loggedUserIsMerchant'
        }),
        ...mapState({
            cart: state => state.watch.cart,
            user: state => state.session.user,
            isLoadingCart: state => state.watch.loadingCart
        }),
        routes() {
            return [
                { name: 'announcements', icon: 'notification', for: [Role.admin, Role.client, Role.merchant] },
                { name: 'listWatches', icon: 'clock-circle', for: [Role.admin, Role.client, Role.merchant] },
                { name: 'orders', icon: 'profile', for: [Role.admin, Role.client, Role.merchant] },
                { name: 'settings', icon: 'setting', for: [Role.admin] },
                { name: 'brands', icon: 'skin', for: [Role.admin] },
                { name: 'users', icon: 'team', for: [Role.admin] },
            ].filter(route => route.for.includes(this.user.type))
        },
        actions() {
            return [
                { type: 'plus-circle', action: (index) => this.incrementPartQuantity(index) },
                { type: 'minus-circle', action: (index) => this.decrementPartQuantity(index) },
                { type: 'delete', action: (index) => this.removeFromCart(index) },
            ]
        },
    }
}
</script>

<style lang="scss" scoped>
    #components-layout-demo-custom-trigger {

        .trigger {
            font-size: 18px;
            line-height: 64px;
            padding: 0 24px;
            cursor: pointer;
            transition: color 0.3s;

            &:hover {
                color: #1890ff;
            }
        }

        .logo {
            background: rgba(255, 255, 255, 1);
            margin: 0 0 5px 0;
            padding: 8px 10px;
            border-radius: 0 0 0 20px;
            height: 64px;
            display: flex;
            align-items: center;
            justify-content: center;
        }
    }
</style>
